import React from 'react';
import intl from 'react-intl-universal';

const Help = () => (
  <div className="content">
    <h1>{intl.get('help.title')}</h1>
    <div className="instructions">{intl.get('help.instructions.corporate')}</div>
    <div className="instructions">{intl.get('help.instructions.ey')}</div>
  </div>
);

export default Help;



// WEBPACK FOOTER //
// ./src/ui/features/Help/Help.js